import { ICreateAndUpdateCompany } from "../../../types/company.interface";
import customAxios from "../../customAxios";
import { UPDATE_COMPANY } from "../../routes";
// import { PAY_DEBT_BY_ADMIN_PUT } from "../../routes";

const updateCompany = async (props: ICreateAndUpdateCompany) => {
  const body = {
    firstName: props?.firstName,
    municipality: props?.municipality,
    lastName: props?.lastName,
    phoneNumber: props?.phoneNumber,
    userName: props?.userName,
    password: props?.password,
    name: props?.name,
    logo: props?.logo,
    address: props?.address,
    lat: props?.lat,
    lng: props?.lng,
    workTimes: props?.workTimes,
    cities: props?.cities,
  };

  try {
    return (await customAxios.put(UPDATE_COMPANY + `/${props._id}`, body)).data;
  } catch (error: unknown) {
    console.error({ UPDATE_ADMIN: error });
    return false;
  }
};

export default updateCompany;
